import { FC } from 'react'
import cx from 'classnames'

import { ModalProps } from '../Modal'
import { AdsReplyFormProps } from '../../forms/AdsReplyForm'

import * as SC from './styled'

export type AdsFormReplyModalProps = ModalProps & {
  className?: string
  form: AdsReplyFormProps
}

const AdsFormReplyModal: FC<AdsFormReplyModalProps> = ({
  className,
  form,
  ...modal
}) => {
  return (
    <SC.ModalStyled className={cx('AdsFormReplyModal', className)} {...modal}>
      <SC.Form {...form} />
    </SC.ModalStyled>
  )
}

export default AdsFormReplyModal
